<template>
  <div class="from-dialog">
    <!-- 体验表单 -->
    <div class="form-box">
      <div class="form">
        <img src="../../assets/img/formImg/close.png" class="close" @click="closeDialog">
        <iframe id="d8d69e2f23ae4bca93d5bd6b3bc7874e" width="100%" height="100%" frameborder="0" src="https://app.swhudong.com/apply/d8d69e2f23ae4bca93d5bd6b3bc7874e" onload="this.style.height='100%'"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
  import { sendCode, submitForm, queryCompanyName } from '../../api/form';

  export default {
    name: 'UploadApplicationForm',
    data() {
      return {
        formData: {
          companyname: '', // 企业名称
          username: '',
          phone: '',
          checkCode: '', // 验证码
          sourceway: '', // 访问途径
          registerProduct: '轻骑兵', // 注册信息的产品
          interestProduct: '轻骑兵', // 感兴趣产品
          concreteDemand: '', // 具体需求
          appName: '',
          appDesc: '',
        },
        formRules: {
          appName: [{ required: true, message: ' ', trigger: 'blur' },],
          appDesc: [{ required: true, message: ' ', trigger: 'blur' },],
          companyname: [{ required: true, message: ' ', trigger: 'blur' },],
          username: [{ required: true, message: ' ', trigger: 'blur' },],
          phone: [{ required: true, message: ' ', trigger: 'blur' },],
          checkCode: [{ required: true, message: ' ', trigger: 'blur' },],
        },
        isSubmit: false,
        companies: [],
        isSend: false,
      };
    },
    methods: {
      // 查询单位名称
      async querySearch(queryString, cb) {
        const self = this;
        let resList = [];
        await queryCompanyName({word: queryString}).then((res) => {
          if ((res.status === '200' || res.status === 200)) {
            if(res.data.result !=null){
              resList = res.data.result.items || [];
              cb(resList);
            }
          } else {
            self.$message.error(res.data);
          }
        }).catch((error) => {
        });
        console.log(resList);
      },
      // 校验手机号
      checkPhone() {
        const self = this;
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(self.formData.phone)) {
          self.$message.error('请输入正确的联系方式!');
          return false;
        }
        return true;
      },
      // 发送验证码
      sendCode() {
        const self = this;
        self.isSend = true;
        if (!self.checkPhone()) {
          self.isSend = false;
          return;
        }
        sendCode(self.formData.phone).then((res) => {
          if ((res.status === '200' || res.status === 200) && res.data === '发送成功') {
            self.$message.success('验证码发送成功!');
          } else {
            self.$message.error(res.data);
          }
          self.isSend = false;
        }).catch((error) => {
          self.$message.error('验证码发送失败!');
          self.isSend = false;
        });
      },
      // 提交表单
      submit() {
        const self = this;
        let error = false;
        self.$refs.form.validate((valid) => {
          error = !valid;
        });
        if (error) {
          return;
        }
        self.formData.concreteDemand = "应用名称：" + self.formData.appName + ",应用简介：" + self.formData.appDesc
        const param = self.formData;
        submitForm(param).then((res) => {
          if ((res.status === '200' || res.status === 200) && res.data === '注册成功') {
            self.$message.success('提交成功!');
            self.isSubmit = true;
          } else {
            self.$message.error(res.data);
          }
        }).catch((error) => {
          self.$message.error('提交失败!');
        });
      },
      // 关闭弹窗
      closeDialog() {
        const self = this;
        self.$emit('closeUploadForm');
      },
    },
    mounted() {},
  }
</script>
<style scoped>
  .from-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
  .form-box {
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    width: 500px;
    height: 730px;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    z-index: 2000;
  }

  .form {
    position: relative;
    width: 500px;
  }
  .form-con-box {
    padding: 50px 79px 59px 79px;
  }
  .form img.close {
    position: absolute;
    top: 18px;
    right: 21px;
    cursor: pointer;
  }
  .form-con-box .form-title {
    margin-bottom: 10px;
    font-size: 24px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #018DFF;
    line-height: 33px;
    text-align: center;
  }
  .form-con-box .form-tip{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #A7A7A7;
    text-align: center;
    margin-bottom: 30px;
  }
  .form-con >>> .el-form-item {
    position: relative;
    margin-bottom: 0;
  }
  .form-con >>> .el-form-item .el-form-item__label {
    padding: 0;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #60646B;
    line-height: 38px;
    float: left;
    width: 70px;
    text-align: right;
    padding-right: 10px;
  }
  .form-con >>> .el-form-item .el-form-item__content{
    float: left;
    width: 272px;
  }
  .form-con >>> .el-form-item .el-form-item__content > .el-input{
    float: left;
    width: 253px;
  }
  .form-con >>> .el-form-item .el-form-item__content > .el-textarea{
    float: left;
    width: 253px;
  }
  .star {
    color: #FF5804;
    margin-left: 6px;
    line-height: 42px;
  }
  .form-con >>> .el-form-item .el-input__inner {
    width: 253px;
    height: 40px;
    margin-bottom: 12px;
    padding-left: 10px;
    border: 1px solid #D3D6DB;
    border-radius: 4px;
    line-height: 40px;
  }
  .form-con >>> .el-form-item .el-textarea__inner {
    width: 253px;
    margin-bottom: 12px;
    line-height: 34px;
  }
  .form-con >>> .el-form-item.is-error .el-input__inner {border: 1px solid #F56C6C;}
  .form-con >>> .el-form-item .el-form-item__content > div {
    float: left;
  }
  .form-con span.code {
    position: absolute;
    top: 10px;
    right: 30px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #186CF5;
    line-height: 20px;
    cursor: pointer;
  }
  .form-con-box .form-btn {
    width: 100%;
    height: 46px;
    margin-top: 20px;
    background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
    border: none;
    color: #FFF;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
  }
  .form-con-box .form-btn:hover {
    background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
  }
  .form-con >>>  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {display: none;}

  /* 提交成功 */
  .submit-success {
    padding-top: 162px;
    text-align: center;
  }
  .submit-success img {
    margin-bottom: 30px;
  }
  .submit-success .success-title {
    margin-bottom: 7px;
    font-size: 24px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #202124;
    line-height: 33px;
  }
  .submit-success .success-tip {
    margin-bottom: 80px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #202124;
    line-height: 22px;
  }
  .submit-success .success-btn {
    width: 110px;
    height: 46px;
    background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
    border: none;
    border-radius: 4px;
    color: #FFF;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
  }
  .submit-success .success-btn:hover {
    background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
  }
  .isDisabled {
    pointer-events: none;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/include/UploadApplicationForm.vue